import { Box } from "@mui/material";
import Header from "./Header/Header";
import Ofertas from "./Ofertas/ofertas";
import Combos from "./Combos/combos";
import Banners from "./Banners/banners";
import { OfertasState } from "../../context/ofertas/OfertasState";
import { CombosState } from "../../context/combos/CombosState";

const Home = () => (
  <Box sx={{
    display: "flex",
    flexDirection: "column",
    width: "100%",
    maxWidth: "var(--container-max)",
    mx: "auto",
    gap: { xs: "var(--space-lg)", md: "var(--space-xl)" },
    pb: { xs: "calc(var(--space-3xl) + var(--mobile-bottom-bar))", md: "var(--space-3xl)" },
    animation: "fadeIn 0.4s ease both",
    "@keyframes fadeIn": {
      from: { opacity: 0 },
      to:   { opacity: 1 },
    },
  }}>
    <Header />
    <Banners />
    <OfertasState><Ofertas /></OfertasState>
    <CombosState><Combos /></CombosState>
  </Box>
);

export default Home;